import "core-js/modules/es.array.iterator.js";
export const getBrowserLang = () => {
  const fullyLang = navigator.language;
  if (fullyLang) {
    const [lang] = fullyLang.split('-');
    return lang ? lang.toLocaleLowerCase() : null;
  } else return null;
};